// src/utils/navigation.js
// Keeps FinVault internal pages inside the installed PWA/TWA shell.
// External links are opened in a separate browser tab only after strict URL validation.

const ALLOWED_EXTERNAL_HOSTS = new Set([
  "wa.me",
]);

export function isStandaloneApp() {
  if (typeof window === "undefined") return false;
  const standaloneMedia = window.matchMedia?.("(display-mode: standalone)")?.matches;
  const fullscreenMedia = window.matchMedia?.("(display-mode: fullscreen)")?.matches;
  const iosStandalone = window.navigator?.standalone === true;
  const androidTwa = typeof document !== "undefined" && document.referrer?.startsWith("android-app://");
  return Boolean(standaloneMedia || fullscreenMedia || iosStandalone || androidTwa);
}

export function safeInternalPath(path = "/") {
  const value = String(path || "/").trim();
  if (!value.startsWith("/") || value.startsWith("//")) return "/";
  return value;
}

export function openInternalPage(path = "/") {
  if (typeof window === "undefined") return;
  window.location.assign(safeInternalPath(path));
}

export function safeExternalUrl(url = "") {
  if (typeof window === "undefined") return "";
  const raw = String(url || "").trim();
  if (!raw) return "";

  try {
    const parsed = new URL(raw, window.location.origin);

    // FinVault only opens approved HTTPS destinations through this helper.
    // This blocks javascript:, data:, file:, plain HTTP, and unknown hosts.
    if (parsed.protocol !== "https:") return "";
    if (parsed.username || parsed.password) return "";
    if (parsed.port && parsed.port !== "443") return "";

    const hostname = parsed.hostname.toLowerCase();
    if (!ALLOWED_EXTERNAL_HOSTS.has(hostname)) return "";

    // Same-origin app navigation must always use openInternalPage().
    if (parsed.origin === window.location.origin) return "";

    return parsed.href;
  } catch (_) {
    return "";
  }
}

export function openExternalPage(url) {
  if (typeof window === "undefined") return;
  const safeUrl = safeExternalUrl(url);
  if (!safeUrl) return;
  window.open(safeUrl, "_blank", "noopener,noreferrer");
}
